import axios from '@/libs/api.request'

/**
 * 报告详情
 */
export const mergeInfo = (report_type, hole_id, segment_no, pwd, projectId) => {
    const data ={
        "report_type": report_type,
        "hole_id": hole_id,
        "segment_no": segment_no,
        "pwd": pwd,
        "projectId": projectId
    }
    return axios.request({
        url: '/api/api/treed/mergeInfo',
        data,
        method: 'post'
    })
}

/**
 * 报告详情
 */
export const reportInfo = (id, pwd, projectId) => {
    const data ={
        "id": id,
        "pwd": pwd,
        "projectId": projectId
    }
    return axios.request({
        url: '/api/api/treed/reportInfo',
        data,
        method: 'post'
    })
}